// @flow
import React from 'react'
import { Link } from 'gatsby'
import { Helmet } from 'react-helmet'
import Layout from '../layout'

function AboutPage() {
  return (
    <Layout>
      <Helmet>
        <title>About</title>
      </Helmet>
      <h1>About</h1>
      <p>
        We welcome you to take part in a conference that strives to present and
        discuss the plurality of approaches to the scholarly <b>pub</b>
        lishing and assessment (<b>met</b>rics) and new trends in the scholarly
        publishing area. The <b>PUBMET</b>2019 conference will present
        innovative approaches, best practice discussions and take on future
        challenges. The organizers aim to maintain lively discussion among
        experts in various fields involved in scholarly publishing and
        dissemination of knowledge. The field of scholarly publishing and
        metrics includes all disciplines and variety of skills: researchers from
        different research areas, information specialists and librarians,
        editors, publishers, educators and students, policy makers and managers
        contribute to this field of investigation.
      </p>
      <p>
        <Link to="/organization">See our organization team →</Link>
      </p>
      <h2>History</h2>
      <p>
        The 1st PUBMET2014 conference under the title “The Plurality of
        Approaches to the Scholarly Publishing and Assessment – Trends and
        Practices in the Scholarly Communication, Metrics and Assessment” was
        organized by the University of Zadar as part of the 10th Anniversary of
        the Department of Information Sciences, and was held on September 18-19,
        2014 in Zadar, Croatia. PUBMET conference encompasses two main themes:
        the first is directed towards scholarly communication and publishing as
        the most visible channel, and the second towards metrics and assessment.
        From the very beginning the organisers were committed to ensuring
        continuity of the PUBMET conference, which was planned to be held
        annually.
      </p>
      <p>
        The next year, on September 24-25 the 2nd PUBMET2015 conference was held
        in Zadar under the title “Scholarly Publishing in the Context of Open
        Science”. It was organized by the Department of Infomation Sciences,
        University of Zadar and Ruđer Bošković Institute, Zagreb, as a
        coorganizer.
      </p>
      <p>
        The 3rd PUBMET2016 conference was also held in Zadar, on October 20-21,
        2016, and at this conference University of Zagreb joined the Organizing
        committee for the first time.
      </p>
      <p>
        Taking into account that many participants were not able to reach Zadar
        in previous years, the 4th PUBMET2017 was organized in Zagreb, on
        September 21-22, 2017 with the pre-conference day on September 20, at
        the Faculty of Engineering and Computing of the University of Zagreb. It
        has attracted 148 participants from 12 countries (Belgium, Czech
        Republic, Germany, Iran, India, Italy, The Netherlands, Norway,
        Slovenia, UK, United States and Croatia) and during the conference 23
        lectures, 5 workshops and discussion session were held, along with the
        poster session. The conference was supported by the Ministry of Science
        and Education of the Republic of Croatia and OpenAIRE.
      </p>
      <p>
        The 5th PUBMET2018 conference was held in Zadar on September 20-21,
        2018, with the pre-conference day on September 19. The organizers are
        University of Zagreb, Faculty of Food Technology and Biotechnology,
        University of Zadar, Department of Infomation Sciences and Ruđer
        Bošković Institute.
      </p>
      <p>
        The themes of the conference were mostly focused on openness (open
        science, open data, open scholarly communication, open repositories,
        open peer review), publication and editorial practices, authorship and
        copyright, plagiarism and ethical issues, advances in digital scholarly
        publishing, bibliometrics, altmetrics, with the aim to bring together a
        diverse community of researchers, university teachers, publishers,
        editors, librarians/information specialists, policy-makers, as well as
        experts from other fields of research and development.
      </p>
      <p>
        The 1st PUBMET2014 conference under the title “The Plurality of
        Approaches to the Scholarly Publishing and Assessment – Trends and
        Practices in the Scholarly Communication, Metrics and Assessment” was
        organized by the University of Zadar as part of the 10th Anniversary of
        the Department of Information Sciences, and was held on September 18-19,
        2014 in Zadar, Croatia. PUBMET conference encompasses two main themes:
        the first is directed towards scholarly communication and publishing as
        the most visible channel, and the second towards metrics and assessment.
        From the very beginning the organisers were committed to ensuring
        continuity of the PUBMET conference, which was planned to be held
        annually.
      </p>
      <p>
        The next year, on September 24-25 the 2nd PUBMET2015 conference was held
        in Zadar under the title “Scholarly Publishing in the Context of Open
        Science”. It was organized by the Department of Infomation Sciences,
        University of Zadar and Ruđer Bošković Institute, Zagreb, as a
        coorganizer.
      </p>
      <p>
        The 3rd PUBMET2016 conference was also held in Zadar, on October 20-21,
        2016, and at this conference University of Zagreb joined the Organizing
        committee for the first time.
      </p>
      <p>
        Taking into account that many participants were not able to reach Zadar
        in previous years, the 4th PUBMET2017 was organized in Zagreb, on
        September 21-22, 2017 with the pre-conference day on September 20, at
        the Faculty of Engineering and Computing of the University of Zagreb. It
        has attracted 148 participants from 12 countries (Belgium, Czech
        Republic, Germany, Iran, India, Italy, The Netherlands, Norway,
        Slovenia, UK, United States and Croatia) and during the conference 23
        lectures, 5 workshops and discussion session were held, along with the
        poster session. The conference was supported by the Ministry of Science
        and Education of the Republic of Croatia and OpenAIRE.
      </p>
      <p>
        The 5th PUBMET2018 conference was held in Zadar on September 20-21,
        2018, with the pre-conference day on September 19. The organizers are
        University of Zagreb, Faculty of Food Technology and Biotechnology,
        University of Zadar, Department of Infomation Sciences and Ruđer
        Bošković Institute.
      </p>
      <p>
        The themes of the conference were mostly focused on openness (open
        science, open data, open scholarly communication, open repositories,
        open peer review), publication and editorial practices, authorship and
        copyright, plagiarism and ethical issues, advances in digital scholarly
        publishing, bibliometrics, altmetrics, with the aim to bring together a
        diverse community of researchers, university teachers, publishers,
        editors, librarians/information specialists, policy-makers, as well as
        experts from other fields of research and development.
      </p>
    </Layout>
  )
}

export default AboutPage
